import { Divider, Drawer, LinearProgress } from '@mui/material';
import React from 'react';
import { toFixedTrunc } from '../../../client/Juno/helpers';
import { useSelector } from 'react-redux';
import { currencyColors } from '../../helpers/constant';
import PropTypes from 'prop-types';

const OverviewSummaryForMobileView = ({
    transformedBalances,
    totalAmount,
    openModal,
    setOpenModal,
}) => {
    const imageBaseUrl = useSelector(state => state.config.image_base_url);

    return (
        <div>
            <Drawer
                anchor="bottom"
                open={openModal}
                onClose={() => setOpenModal(false)}
                PaperProps={{
                    sx: {
                        borderRadius: '12px ',
                        paddingBottom: 2,
                        margin: '20px',
                    },
                }}>
                <div className="flex justify-center">
                    {openModal && (
                        <div className="fixed transform -translate-y-2 ">
                            <p className="w-[83px] h-[5px] rounded-[11px] bg-white" />
                        </div>
                    )}
                </div>
                <div className="flex flex-col justify-center items-center gap-1 pt-6 pl-4 pr-4 pb-2 md:px-6 md:pt-6 md:pb-2 self-stretch">
                    <p className="text-gray-900 text-[26px] font-semibold leading-6">
                        <span className="text-[18px] mr-0.5">$</span>
                        {`${toFixedTrunc(totalAmount, 2)}`}
                    </p>
                    {/* <p className='text-gray-600 font-inter text-xs font-medium leading-[18px]'>
                        24H CHANGE
                        <span className='text-[#4CA30D] text-center text-xs font-medium leading-[18px]'>+200%</span>
                    </p> */}
                </div>

                <Divider />

                <div className="flex justify-between flex-col gap-8 pt-3 px-4 pb-4 md:pl-6 md:pr-6 md:pb-6 self-stretch">
                    {transformedBalances?.map(item => (
                        <div className="flex justify-between" key={item.currency}>
                            <div className="flex justify-center items-center gap-3">
                                <img
                                    src={`${imageBaseUrl}${item?.icon}`}
                                    className="w-6 h-6"
                                    alt="currencyIcon"
                                />
                                <span className="text-sm text-[#18181B] font-semibold leading-5">
                                    {item?.currency}
                                </span>
                            </div>

                            <div className="w-32 flex flex-col">
                                <p className="ml-auto text-sm text-[#18181B] font-semibold leading-5">
                                    {toFixedTrunc(item?.holdingPercentage, 2)}%
                                </p>
                                <LinearProgress
                                    variant="determinate"
                                    value={item?.holdingPercentage}
                                    sx={{
                                        '&&': {
                                            backgroundColor: '#FFFFFF3D',
                                            transform: 'rotateY(180deg)',
                                            '& .MuiLinearProgress-bar': {
                                                transform: 'rotateY(180deg)',
                                                backgroundColor: currencyColors.find(
                                                    colorItem =>
                                                        colorItem?.symbol === item?.currency,
                                                )?.color,
                                            },
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </Drawer>
        </div>
    );
};
OverviewSummaryForMobileView.propTypes = {
    transformedBalances: PropTypes.array.isRequired,
    totalAmount: PropTypes.number.isRequired,
    openModal: PropTypes.bool.isRequired,
    setOpenModal: PropTypes.func.isRequired,
};

export default OverviewSummaryForMobileView;
